
import {
	createRouter,
	createWebHistory
} from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store/index.js'
import {
	checkAuth
} from "@/api/index.js"

const routes = [
	{
		name: "index",
		path: "/",
		redirect: "/login"
	}, {
		name: "login",
		path: "/login",
		component: () => import("@/pages/login.vue")
	}, {
		name: "503",
		path: "/noauth",
		component: () => import("@/pages/err_no_auth.vue")
	}, {
		name: "404",
		path: "/:pathMatch(.*)*",
		component: () => import("@/pages/err_404.vue")
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {
	console.log(to.path,'to.path')
	NProgress.start()
	// 将token保存到本地
	const obj=localStorage.getItem('loginSession')
	const sessionId=JSON.parse(obj)?.sessionId


	// 判断store中是否有token，且本地有，去的还不是login（刷新的情况）刷新会丢失vuex中的token
	if(sessionId && to.path!='/login' && !store.getters.getSessionId){
		// 将token保存到vuex中否则会进入死循环。
		let sessionStorageTab = JSON.parse(
			window.sessionStorage.getItem("set_tabs")
		);
		store.dispatch("set_tabs", sessionStorageTab);
		store.dispatch("set_selectedTab", to.path);
		store.dispatch("set_loginStatus", JSON.parse(obj));
		try {
			// vuex中的方法：获取到当前登录用户的路由权限菜单。然后动态注册。
			// 验证用户权限的俩种方法：一：动态路由注册。二：后端验证登录用户的路由权限。
			// 都是需要动态的生成菜单
			store.dispatch("set_naviData")
				
			
			// 解决首页白屏问题。
			next({...to})
			return
		} catch (error) {
			next('/login')
			return
		}
		
	}
	// if (!store.getters.getSessionId  && to.path != "/login") {
	// 	console.log(store.getters.getSessionId,'sessionid')
	// 	next("/login")
	// 	return
	// }
	if (to.path != "/login" && to.path != "/home") {
		
		store.dispatch("set_currentChildRouterPath", to.path)
	
	}
	next()
	return
	// if (to.meta.auth === true) {
	// 	if (!store.getters.getUserName) {
	// 		next("/")
	// 	} else {
	// 		checkAuth(to.path).then(data => {
	// 			if (data.code == 0) {
	// 				if (data.success === true) {
	// 					next()
	// 				} else {
	// 					next("/home/home_503")
	// 				}
	// 			} else {
	// 				next("/home/home_503")
	// 			}
	// 		}).catch(() => {
	// 			next("/home/home_503")
	// 		})
	// 	}
	// } else {
	// 	if (to.path == "/home/undefined") {
	// 		next("/home")
	// 		return
	// 	}
	// 	next()
	// }
})

router.afterEach(() => {
	NProgress.done()
})

export default router
